<template>
  <v-app>

    <v-main style="background: linear-gradient(-225deg, #65379B 0%, #886AEA 53%, #6457C6 100%) !important;">
      <v-container style="width: 100% ; padding:15px">
        <v-row>
          <v-col>
            <slot></slot>
          </v-col>
        </v-row>

      </v-container>
    </v-main>

  </v-app>
</template>

<script>
export default {}
</script>

<style scoped>
.theme--light.v-card {
  background-color: #ffffffc7 !important;
  color: rgba(94, 86, 105, 0.87) !important;
  margin: 15px;
  max-width: 1300px;
  margin: auto;
  margin-top: 20px;
 min-height: 400px !important;
}

footer {
  display: none !important;
}
</style>
